import { render, staticRenderFns } from "./PaymentFrame.vue?vue&type=template&id=c8e188d6&scoped=true&lang=pug&"
import script from "./PaymentFrame.vue?vue&type=script&lang=js&"
export * from "./PaymentFrame.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFrame.vue?vue&type=style&index=0&id=c8e188d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e188d6",
  null
  
)

export default component.exports